import { render } from "./PropertyModal.vue?vue&type=template&id=13c7ebcc&scoped=true"
import script from "./PropertyModal.vue?vue&type=script&lang=js"
export * from "./PropertyModal.vue?vue&type=script&lang=js"

import "./PropertyModal.vue?vue&type=style&index=0&id=13c7ebcc&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13c7ebcc"]])

export default __exports__